import React, { useLayoutEffect, useEffect, useState } from 'react'

import { useModals } from '../../../PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider'

import {
  fullHeightContainer,
  removeFullHeightContainer,
  userDevice,
  removeDuplicateTickets,
} from '../../../../utilities/helpers'

import { BackButton } from '../../../BackButton'
import { Event } from '../../../PurchaseFlow/components/Event'
import { OrderFoodButton } from '../../../OrderFoodButton'
import { MyTickets } from '../../../MyTickets'
import { ActionBtns } from '../../../ActionBtns'
import { TicketModal } from '../../../TicketModal'

export default function EventDetailsWrapper({ order, getMyTickets }) {
  console.log('order details', order, getMyTickets)

  const { openModal } = useModals()

  const [show, setShow] = useState(false)

  const [ticketAction, setTicketAction] = useState('')

  const [ticketStatus, setTicketStatus] = useState('')

  const [ticket, setTicket] = useState()

  const [deviceType, setDeviceType] = useState('')

  useLayoutEffect(() => {
    const el = document.querySelector('#main-container')

    fullHeightContainer(el)

    return () => {
      removeFullHeightContainer(el)
    }
  }, [])

  const handleShow = () => setShow(true)

  const handleClick = (action, ticket) => {
    handleShow()
    setTicketAction(action)
    setTicket(ticket)
  }

  return (
    <section className="full-height-wrapper">
      <div className="section-heading-sm">
        <h1>Event details</h1>
        <div className="tablet-desktop-only">
          <BackButton />
        </div>
      </div>

      <Event event={order?.event} openModal={openModal} />
      <div className="mb-3">
        <OrderFoodButton order={order} event={order?.event} />
      </div>
      <MyTickets
        order={order}
        handleClick={handleClick}
        ticketStatus={ticketStatus}
      />
      <TicketModal
        ticketAction={ticketAction}
        setTicketStatus={setTicketStatus}
        show={show}
        setShow={setShow}
        ticket={ticket}
        order={order}
        getMyOrders={getMyTickets}
      />
    </section>
  )
}
